import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id 14FABBBE-A903-4400-AC7A-338B46DA0342
 * name rectangle-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rectangle-outline.svg
 * tags
 * - Shape 
 */
export const RectangleOutlineIcon = createSvgIcon(<><path d="M4,6V19H20V6H4M18,17H6V8H18V17Z" /></>, 'RectangleOutlineIcon');
export default RectangleOutlineIcon